import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import PatientInfo from "../Components/PatientInfo";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const Prescription = () => {
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const { id } = useParams();
  const [appointment, setAppointment] = useState({});
  const [medicine, setMedicine] = useState({});
  const [prescribeMedicine, setPrescribeMedicine] = useState([]);
  const [values, setValues] = useState({
    appointment_id: id,
  });
  const medicationRef = useRef(null);
  const frequencyRef = useRef(null);
  const durationRef = useRef(null);
  const instructionRef = useRef(null);
  const durationstrRef = useRef(null);
  const [prescription, setPrescription] = useState({});

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(`appointment/${id}`);
        setAppointment(response?.data);
      } catch (err) {
        showAlert("Load Failed.", "warning");
      }
    };

    const fetchMedicine = async () => {
      try {
        const response = await axiosPrivate.get("prescription/medicine/list");
        setMedicine(response?.data);
      } catch (err) {
        showAlert("Load Failed.", "warning");
      }
    };
    fetchData();
    fetchMedicine();
  }, []);

  const onBoxChange = (e, medicine) => {
    //checks if event is trigerred from drowpdown and the option chosen is not default
    if (e.target.name === "medicine") {
      if (
        e.target.value !== "Select Medicine" &&
        e.target.value !== "No Medicine"
      ) {
        const selectedId = e.target.value;
        //gets the detail of medicine selected
        const selectedMedicine = medicine.find(
          (med) => med.medicine_name === selectedId
        );

        setPrescription({
          ...prescription,
          id: selectedMedicine.id,
          name: selectedMedicine.medicine_name,
        });
      }
    } else if (e.target.name === "duration_str") {
      if (e.target.value !== "Choose") {
        setPrescription({ ...prescription, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "description") {
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setPrescription({ ...prescription, [e.target.name]: e.target.value });
    }
  };

  const onAdd = (e) => {
    const frequency = `${prescription.frequency} times`;
    const duration = `${prescription.duration} ${prescription.duration_str}`;
    if (prescription.id === undefined) {
      showAlert("Select medicine.", "warning");
    } else if (prescription.frequency === undefined) {
      showAlert("Select frequency.", "warning");
    } else if (duration === null || prescription.duration_str === undefined) {
      showAlert("Select duration.", "warning");
    } else if (prescription.instruction === undefined) {
      showAlert("Give instruction.", "warning");
    } else {
      const selectedId = prescription.id;
      //gets the detail of medicine selected
      const selectedMedicine = medicine.find((med) => med.id === selectedId);

      //checks if medicine is already stored or not
      if (
        !prescribeMedicine.find((med) => med.medicine === selectedMedicine.id)
      ) {
        //add the newly selected medicine

        setPrescribeMedicine([
          ...prescribeMedicine,
          {
            medicine: prescription.id,
            name: prescription.name,
            frequency: frequency,
            duration: duration,
            instruction: prescription.instruction,
          },
        ]);

        //resetting input field to null
        medicationRef.current.value = "Select Medicine";
        frequencyRef.current.value = "";
        durationRef.current.value = "";
        instructionRef.current.value = "";
        durationstrRef.current.value = "Choose";
      } else {
        showAlert("You have already prescribed this medicine.", "warning");
      }
    }
  };

  const onDelete = (id) => {
    //gets the value except for the passed id
    const updatedValue = prescribeMedicine.filter(
      (value) => value.medicine !== id
    );
    //sets new remaining values to state
    setPrescribeMedicine(updatedValue);
  };

  const prescribeClick = async () => {
    // checks if note is added
    if (values?.description === undefined) {
      showAlert("Add Note.", "warning");
    } else {
      //gets the detail of selected medicine and stores in object type
      const newMedicine = prescribeMedicine.map((med) => ({
        medicine: med.medicine,
        frequency: med.frequency,
        duration: med.duration,
        instruction: med.instruction,
      }));

      //adds object of medicine to value
      values["medicines"] = newMedicine;
      try {
        await axiosPrivate.post("prescription/", values);

        navigate("/list/appointment", {
          state: {
            message: "Appointment has been prescribed.",
            type: "success",
          },
        });
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else if (err.response?.status === 400) {
          showAlert("Prescription already exists.", "warning");
        } else {
          showAlert("Prescription Failed", "warning");
        }
      }
    }
  };

  return (
    <div>
      {appointment?.is_completed ? (
        <h2 className="text-center py-2 mt-5">You Have Already Prescribed</h2>
      ) : appointment?.doctor_id !== auth?.user["id"] ? (
        <h2 className="text-center py-2 mt-5">
          You can only prescribe to appointment scheduled for you.
        </h2>
      ) : (
        <>
          <AlertField alert={alert} />

          <h2 className="text-center py-2">Give Prescription</h2>

          <div className="mx-5 px-5 bg-light row row-cols-2">
            <div className="p-5 col" style={{ borderRight: "4px solid white" }}>
              <PatientInfo appointment={appointment} />
              <h4>Prescription</h4>
              <div className="card py-4 ps-4">
                <div className="ms-4 d-flex">
                  <h5 className="mt-3">Medication</h5>
                  <select
                    id="inputState"
                    className="form-select w-50 mx-5 mt-2 p-2"
                    name="medicine"
                    style={{ height: 3 + "rem", overflowY: "auto" }}
                    onClick={(event) => onBoxChange(event, medicine)}
                    ref={medicationRef}
                  >
                    <option>Select Medicine</option>
                    {medicine?.length ? (
                      medicine?.map((name, i) => (
                        <option key={i} value={medicine.id}>
                          {name.medicine_name}
                        </option>
                      ))
                    ) : (
                      <option>No Medicine</option>
                    )}
                  </select>
                </div>
                <div className="ms-4 d-flex my-4">
                  <h5 className="me-5">Frequency</h5>
                  <input
                    className="ms-2"
                    placeholder="Daily Dose"
                    type="number"
                    name="frequency"
                    onChange={onBoxChange}
                    ref={frequencyRef}
                  />
                </div>
                <div className="ms-4 d-flex mb-4">
                  <h5 className="me-5">Duration</h5>
                  <input
                    className="ms-4 w-25"
                    type="number"
                    id="duration"
                    name="duration"
                    placeholder="Consume days"
                    onChange={onBoxChange}
                    ref={durationRef}
                  />
                  <select
                    className="mx-1 p-1"
                    name="duration_str"
                    onChange={onBoxChange}
                    ref={durationstrRef}
                  >
                    <option>Choose</option>
                    <option>Days</option>
                    <option>Month</option>
                  </select>
                </div>
                <div className="ms-4 d-flex">
                  <h5 className="me-5">Instruction</h5>
                  <input
                    className="ms-1 w-50"
                    type="text"
                    id="instruction"
                    name="instruction"
                    placeholder="How medicine should be taken?"
                    onChange={onBoxChange}
                    ref={instructionRef}
                  />
                </div>
                <div>
                  <button
                    className="btn btn-success position-absolute top-0 end-0"
                    onClick={onAdd}
                  >
                    <i className="fa-solid fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="col p-5 position-relative">
              <section className="rounded-3 border my-3 p-2">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Medication</th>
                      <th>Doses</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {prescribeMedicine.length ? (
                      prescribeMedicine?.map((medicine, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{medicine?.name}</td>
                          <td>{medicine?.frequency}</td>
                          <td>
                            <button
                              className="btn border-0 p-0 mx-1 mb-1"
                              onClick={() => onDelete(medicine.medicine)}
                            >
                              <i className="fas text-danger fa-xmark"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          No medicine prescribed.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </section>
              <h5 className="mt-4">Note</h5>
              <textarea
                className="w-100 p-2"
                rows={5}
                name="description"
                id="description"
                onChange={onBoxChange}
              ></textarea>
              <div
                className="w-100 text-center position-absolute mb-2"
                style={{ bottom: 0 }}
              >
                <button className="btn btn-primary" onClick={prescribeClick}>
                  Prescribe
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Prescription;
